import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { UserService } from '@core/services/user.service';

@Component({
  selector: 'app-login',
  imports: [AsyncPipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {

  public _userService = inject(UserService);

  public login() {
    this._userService.login();
  }

  public signUp() {
    this._userService.signUp();
  }

  public logout() {
    this._userService.logout();
  }

}
